/* eslint-disable */
// src/utils/accumulationModeLabels.js

export function getAccumulationModeLabel(value) {
  if (value === true) return "Acumulativa";
  if (value === false) return "Con borrado";
  return "Sin dato";
}
